"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgSync = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M7.423 16c1 1.194 2.535 1.999 4.607 1.998 3.553-.002 5.53-2.37 5.926-5.003.05-.329.208-.995 1.07-.995.862 0 .983.666.943.991A8.002 8.002 0 016 17.258v1.813a1 1 0 11-2 0V15a1 1 0 011-1h4.073a1 1 0 010 2h-1.65zm9.188-7.929c-.997-1.233-2.553-2.07-4.665-2.069-3.553.002-5.53 2.37-5.926 5.003-.05.329-.208.995-1.07.995-.863 0-.983-.666-.943-.991a8.001 8.001 0 0114.066-4.153V5a1 1 0 012 0v4.071a1 1 0 01-1 1H15a1 1 0 110-2h1.611z' }))); };
exports.default = SvgSync;
//# sourceMappingURL=Sync.js.map